import React from 'react';
import { ChevronLeft } from '../../assets/Icons';
import { ENDPOINTS } from '../../pages/utils/endpoints';
import '../../pages/authentication/AuthRedesign.scss';

// Placeholder testimonials — swap for real customers before launch.
const QUOTES = [
    ['NORTHWIND', '"We replaced a 20-page PDF with three UserNurture walkthroughs. New-customer setup tickets dropped by half in the first month."', 'Priya Nadella', ', Head of Customer Success, Northwind'],
    ['MERIDIAN', '"Our onboarding used to be a Zoom call and a hope. Now every new user walks the product hands-on and we see exactly where they get stuck."', 'Daniel Cho', ', VP Product, Meridian'],
    ['LUMEN', '"Rolling training out to 400 employees used to take weeks. With Paths, people self-serve and we track completion in one place."', 'Sofia Marín', ', Head of Enablement, Lumen'],
    ['BRIGHTPATH', '"Support volume on our top three how-to questions is down 60%. The guides just answer them before a ticket is ever opened."', 'Marcus Bell', ', Support Lead, Brightpath'],
    ['VERTEX', '"We shipped our first interactive walkthrough the same afternoon we signed up. It genuinely took minutes, not days."', 'Aisha Rahman', ', Founder, Vertex'],
    ['ORBIT', '"Inviting the team and assigning training took five minutes. Everyone was onboarded by the end of the week."', 'Tom Fielder', ', Ops Manager, Orbit']
];

const RegistrationLayout = ({
    children,
    title,
    currStep,
    totalSteps,
    onBackClick
}) => {
    const logo = require('../../assets/usernurture-logo.png');
    const pips = Array.from({ length: totalSteps });
    const q = QUOTES[(currStep - 1) % QUOTES.length] || QUOTES[0];

    return (
        <div className="un-auth">
            <div className="un-auth__form">
                <div className="un-auth__top">
                    <a href={ENDPOINTS.ROOT}>
                        <img src={logo} alt="UserNurture" className="un-auth__logo" />
                    </a>
                    <a
                        className="un-auth__logout"
                        rel="nofollow"
                        data-method="delete"
                        href={ENDPOINTS.USER_SIGNOUT}
                    >
                        Log out
                    </a>
                </div>

                <div className="un-auth__body un-auth__body--top">
                    <div className="un-auth__pips" style={{ marginBottom: 22 }}>
                        {pips.map((_, i) => (
                            <b key={i} className={i < currStep ? 'on' : ''} />
                        ))}
                    </div>

                    {currStep > 1 && (
                        <button type="button" className="un-auth__back" onClick={onBackClick}>
                            <ChevronLeft />
                            Back
                        </button>
                    )}

                    {title}

                    <div className="un-auth__onboard">{children}</div>
                </div>

                <div className="un-auth__foot">
                    <span>© 2026 UserNurture</span>
                    <span>
                        <a href="https://usernurture.com/terms">Terms</a> · <a href="https://usernurture.com/privacy">Privacy</a>
                    </span>
                </div>
            </div>

            {/* Brand panel — placeholder testimonial + logo wall; swap for real customers before launch. */}
            <div className="un-auth__brand">
                <div className="un-auth__quote">
                    <div className="un-auth__quote-logo">{q[0]}</div>
                    <div className="un-auth__quote-text">{q[1]}</div>
                    <div className="un-auth__quote-by">
                        <b>{q[2]}</b>
                        <span>{q[3]}</span>
                    </div>
                </div>
                <div className="un-auth__logowall">
                    <span>ACME</span><span>Northwind</span><span>Lumen</span><span>Brightpath</span><span>Vertex</span>
                    <span>Cedar</span><span>Meridian</span><span>Kova</span><span>Fielding</span><span>Orbit</span>
                </div>
            </div>
        </div>
    );
};

RegistrationLayout.defaultProps = {
    title: '',
    currStep: 1,
    totalSteps: 6,
    onBackClick: () => {}
};

export default RegistrationLayout;
